(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-drawer-content/assets/javascripts/betslip-drawer-content.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-drawer-content/assets/javascripts/betslip-drawer-content.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;

const ReactIcon = svs.ui.ReactIcon;
const CouponOverview = svs.components.tipsen.couponOverview.CouponOverview;
const Betslip = svs.components.tipsen.betslipComponents.Betslip;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectSystemType = _svs$components$tipse.selectSystemType,
  selectIsCouponSingleRows = _svs$components$tipse.selectIsCouponSingleRows,
  selectIsCouponExternal = _svs$components$tipse.selectIsCouponExternal;
const SYSTEM_REDUCERA_FRITT = svs.components.tipsen.engine.constants.systems.SYSTEM_REDUCERA_FRITT;
const ShareCoupon = svs.components.tipsen.shareCoupon.ShareCoupon;
const BetslipDrawerContent = _ref => {
  let _ref$handleOpen = _ref.handleOpen,
    handleOpen = _ref$handleOpen === void 0 ? () => {} : _ref$handleOpen,
    _ref$handleOpenOrClos = _ref.handleOpenOrClose,
    handleOpenOrClose = _ref$handleOpenOrClos === void 0 ? () => {} : _ref$handleOpenOrClos,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  const couponId = useCouponId();
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const isSingleRows = useSelector(state => selectIsCouponSingleRows(state, couponId));
  const isExternal = useSelector(state => selectIsCouponExternal(state, couponId));
  const showShareCoupon = systemType !== SYSTEM_REDUCERA_FRITT && !isSingleRows && !isExternal;
  return React.createElement("div", {
    className: "pg_betslip_drawer_content",
    onClick: handleOpen,
    style: style
  }, React.createElement("div", {
    className: "pg_betslip_drawer_content__tab"
  }, React.createElement("div", {
    className: "pg_betslip_drawer_content__tab__line"
  })), React.createElement("div", {
    className: "pg_betslip_drawer_content__container"
  }, React.createElement("div", {
    className: "pg_betslip_drawer_content__container__header",
    onClick: handleOpenOrClose
  }, React.createElement(ReactIcon, {
    className: "pg_betslip_drawer_content__container__header__icon",
    color: "fc-white",
    icon: "menu-down",
    size: "200"
  }), React.createElement("div", {
    className: "pg_betslip_drawer_content__container__header__text"
  }, "Kupong\xF6versikt")), React.createElement("div", {
    className: "pg_betslip_drawer_content__container__coupon_overview"
  }, React.createElement(CouponOverview, {
    isCompact: true
  })), React.createElement("div", {
    className: "pg_betslip_drawer_content__container__bottom"
  }, React.createElement(Betslip.BalanceView, null), !isSelfService && showShareCoupon && React.createElement(ShareCoupon, {
    className: "margin-top-1 pg_betslip__share_coupon"
  }))));
};
setGlobal('svs.components.tipsen.betslipDrawerContent.BetslipDrawerContent', BetslipDrawerContent);

 })(window);